<template>
  <div class="slider-inner slider-d">
    <Logo />

    <div class="d1 animated fadeInUp">
      <div class="inner">
        <img class="d11 animated fadeIn" src="~images/d/d_1_1.png" />
        <img class="d12 animated fadeInUp" src="~images/d/d_1_2.png" />
        <img class="d13 animated zoomIn" src="~images/d/d_1_3.png" />
        <img class="d14 animated fadeIn45deg" src="~images/d/d_1_4.png" />

        <img class="d15 animated fadeInUp" src="~images/d/d_1_5.png" />
        <div class="d15-fix">
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_5_1.png" />
          </div>
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_5_2.png" />
          </div>
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_5_3.png" />
          </div>
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_5_4.png" />
          </div>
        </div>

        <img class="d16 animated fadeInUp" src="~images/d/d_1_6.png" />
        <div class="d16-fix">
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_6_1.png" />
          </div>
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_6_2.png" />
          </div>
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_6_3.png" />
          </div>
          <div class="item animated zoomIn">
            <img src="~images/d/d_1_6_4.png" />
          </div>
        </div>
      </div>
    </div>
    <img class="d2 animated zoomIn" src="~images/d/d_2.png" />
    <div class="d3 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/d/d_3.png" />
    </div>
    <div class="d4 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_3.png" />
    </div>
    <img class="d5 animated fadeInLeft" src="~images/b/b_7.png" />
    <img class="d6 animated fadeInRight" src="~images/b/b_8.png" />
    <img class="d7" src="~images/b/b_9.png" />
    <div class="d8 animated fadeInRight">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_5.png" />
    </div>

    <Tip />
  </div>
</template>

<script>
export default {
  name: "SliderD",
};
</script>

<style lang="less" scoped>
.slider-d {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  .d1 {
    position: absolute;
    top: 20%;
    right: 5%;
    bottom: 6%;
    left: 5%;
    padding: 0.47rem 0.15rem 0.2rem;
    background: url("~images/d/d_1.png") center top / 100% 100%;
    .inner {
      position: relative;
      height: 100%;
      overflow: auto;
      .d11 {
        padding-top: 1rem;
        margin-bottom: 0.6rem;
      }
      .d12 {
        position: absolute;
        top: 0.3rem;
        left: 50%;
        width: 94%;
        margin-left: -47%;
        animation-delay: 0.5s;
      }
      .d13 {
        position: absolute;
        top: 0.6rem;
        width: 1.73rem;
        animation-delay: 0.5s;
      }
      .d14 {
        position: absolute;
        top: 0.82rem;
        left: 1.7rem;
        width: 1.17rem;
        animation-delay: 0.8s;
      }
      .d15,
      .d16 {
        width: 1.48rem;
        margin: 0 0 0.2rem 0.12rem;
        animation-delay: 1s;
        &-fix {
          display: flex;
          justify-content: space-around;
          padding-bottom: 0.34rem;
          .item {
            width: 1.29rem;
            flex: 0 0 1.29rem;
            animation-delay: 1.3s;
          }
        }
      }
      .d16 {
        width: 1.51rem;
      }
    }
  }
  .d2 {
    position: absolute;
    top: 13.5%;
    left: 50%;
    width: 5.8rem;
    margin-left: -5.8/2rem;
  }
  .d3 {
    position: absolute;
    top: 10%;
    left: 0.55rem;
    width: 1.21rem;
  }
  .d4 {
    position: absolute;
    top: 14.5%;
    right: 0.7rem;
    width: 0.53rem;
  }
  .d5 {
    position: absolute;
    left: 1.2rem;
    bottom: 0;
    width: 1.8rem;
  }
  .d6 {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 2rem;
  }
  .d7 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .d8 {
    position: absolute;
    top: 45%;
    right: 0;
    width: 0.79rem;
    z-index: 5;
  }
}
</style>